import { useTranslation } from 'next-i18next/pages'

import { footerLinks } from 'data/navigation'

import { StyledDescriptionTerms } from './DescriptionTerms.Styled'

export const DescriptionTerms = () => {
  const { t } = useTranslation()

  return (
    <StyledDescriptionTerms
      $variant="Poppins/T4"
      dangerouslySetInnerHTML={{
        __html: t('welcome_age_buckets_legal', {
          0: footerLinks.privacyPolicy.href,
          1: footerLinks.terms.href,
        }),
      }}
    />
  )
}
